export const LS_PERSONAL_ACCESS_TOKEN_KEY = 'xxtools_personal_access_token';
export const LS_GITHUB_OWNER_KEY = 'xxtools_github_owner';
export const LS_GITHUB_REPO_KEY = 'xxtools_github_repo';
